export const ENV = {  
    PRODUCTION : true,
    API_URL    : 'https://cotest.online/klmr_cabsand/index.php/api',
    DEV_URL    : 'https://hub.klmrcivil.com.au/index.php/api',
    QA_URL    :  'https://hub-qa.klmrcivil.com.au/index.php/api',
  };
  
    // QA_URL    : 'https://hub.klmrcivil.com.au/index.php/api',


// WEBPACK FOOTER //
// ./src/env/environment.ts